import React, { useState } from 'react';
import { container } from 'tsyringe';
import { Loader } from '@ui-kit/components/loader';
import { t } from '../../utils/helpers';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import { useHistory } from 'react-router-dom';
import MainButton from '@ui-kit/components/mainButton';
import { ResponseCode, StorageKeys } from '../../utils/constants';
import { useForm, FormProvider } from 'react-hook-form';
import { ILocalStorage } from '@base/features/storage/interfaces';
import { IAuthService, ResponseUserAuthData } from '@base/features/auth/model/interfaces';
import Tabs, { TabPane } from '@ui-kit/components/tabs';
import { PhoneVerification } from '@base/features/auth/components/userVerification/phoneVerification';
import { EmailVerification } from '@base/features/auth/components/userVerification/emailVerification';
import styles from '@base/features/auth/styles/common.module.scss';
import { IModalProvider } from '@base/features/modal/model/interfaces';
import AuthWrapImage from '@base/features/auth/components/authWrapImage';

const VerificationAccountPage = () => {
  const localStorage: ILocalStorage = container.resolve('localStorage');
  const modalProvider: IModalProvider = container.resolve('modalProvider');
  const authService: IAuthService = container.resolve('authService');

  const userAutData = localStorage.get(StorageKeys.TEMP_DATA);
  const { usr, session } = userAutData || '';

  const history = useHistory();
  const [isLoading, setLoading] = useState(false);

  const methods = useForm({
    mode: 'onChange',
    defaultValues: {
      emailValue: '',
      phoneValue: '',
      phoneVerification: {
        token: '',
        regCode: '',
      },
    },
  });
  const { getValues, handleSubmit, formState } = methods;
  const { emailValue } = getValues();

  function goToLogin() {
    history.push(MAIN_ROUTES.login);
    localStorage.delete(StorageKeys.TEMP_DATA);
  }

  const onSubmit = handleSubmit((data) => {
    setLoading(true);
    if (data.emailValue) {
      verificationWithEmail();
      return;
    }
    if (data.phoneValue) {
      verificationWithPhone(usr, session, data.phoneValue, data.phoneVerification.token);
    }
  });

  function verificationWithEmail() {
    authService
      .setEmail(usr, session, emailValue)
      .then((res) => {
        setLoading(false);
        if (res.code === ResponseCode.SUCCESS) {
          modalProvider.show({
            title: t('info'),
            body: 'account_confirmation_email_sent',
            buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
          });
          goToLogin();
        } else if (res.code === ResponseCode.WRONG_EMAIL_OR_PASSWORD) {
          modalProvider.show({
            title: t('ERROR'),
            body: 'enter_valid_email',
            buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
          });
        } else {
          modalProvider.show({
            title: t('ERROR'),
            body: t('unknown_error_try_again'),
            buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
          });
          console.log('verificationWithEmail', res);
        }
      })
      .catch(() => {
        setLoading(false);
        modalProvider.show({
          title: t('ERROR'),
          body: t('unknown_error_try_again'),
          buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
        });
      });
  }

  function verificationWithPhone(usr: string, session: string, phone: string, token: string) {
    authService
      .setUserPhone(usr, session, phone, token)
      .then((response: ResponseUserAuthData) => {
        setLoading(false);
        if (response.code === ResponseCode.SUCCESS) {
          modalProvider.show({
            title: t('info'),
            body: 'request_successfully_submitted',
            buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
          });
          authService.doEntryDefault(userAutData);
          localStorage.delete(StorageKeys.TEMP_DATA);
          goToLogin();
        } else {
          modalProvider.show({
            title: t('ERROR'),
            body: t('unknown_error_try_again'),
            buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
          });
        }
      })
      .catch(() => {
        setLoading(false);
        modalProvider.show({
          title: t('ERROR'),
          body: t('unknown_error_try_again'),
          buttons: [{ title: t('ok'), onClick: () => modalProvider.hide() }],
        });
      });
  }

  return (
    <div className="auth">
      {isLoading && <Loader className="loader-container--black" />}
      <AuthWrapImage />
      <div className="verification-page">
        <div className="register-content-wrap">
          <h1 className="verification__title">{t('you_need_verify_account')}</h1>

          <div className="verification__form">
            <div className="auth-form-item">
              <FormProvider {...methods}>
                <Tabs>
                  <TabPane label="phone" key="1" className={styles.verificationTab}>
                    <PhoneVerification mode="verification" />
                  </TabPane>
                  <TabPane label="email" key="2" className={styles.verificationTab}>
                    <EmailVerification />
                  </TabPane>
                </Tabs>
              </FormProvider>
            </div>

            <div className="verification__btn-wrap">
              <MainButton className="register__btn register__btn-cancel" onClick={goToLogin}>
                {t('cancel')}
              </MainButton>
              <MainButton
                className="register__btn register__btn-sign-up"
                disabled={!formState.isValid}
                onClick={onSubmit}
              >
                {t('send_request')}
              </MainButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationAccountPage;
